:host {
  max-width: 100%;
  --logo-color: var(--black-layout-700-primary);
}

.wrapper {
  padding: 2px;
  border: 1px solid var(--blue-layout-400-primary);
  border-radius: 16px;
  width: 950px;
  overflow: hidden;

  .logo {
    position: absolute;
    right: -50px;
    bottom: -31px;
    width: 250px;
    height: 250px;
  }
}

.container {
  padding: 40px 200px 40px 40px;
}

.title-logo {
  font-size: 50px;
  padding-bottom: calc(var(--spacer) * 3);
  color: var(--logo-color);
}

.content {
  flex: 0.7;
}

.background-logo {
  position: absolute;
  right: 0;
  bottom: 0;
  aspect-ratio: 1;
  height: 100%;
  max-height: 400px;
  transform: translate(20%, 18%);
}

::slotted(*) {
  padding-top: calc(var(--spacer) * 1.5);
  padding-bottom: calc(var(--spacer) * 1.5);
}

::slotted(:first-child) {
  padding-top: 0;
}

::slotted(:last-child) {
  padding-bottom: 0;
}
